// Module
var code = "<div class=\"level-left\" id=\":elementId\"> <div class=\"level-item\"> <label class=\"label\"> :buttonGroupLabel </label> </div> <div class=\"buttons\"></div> </div> ";
// Exports
export default code;